/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { EShapePointsFormatter } from "./e-shape-points-formatter";

export interface EShapePointsFormatterDatum {
	label: string;
	formatter: EShapePointsFormatter;
}
